import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-page-topbar',
    templateUrl: './page-topbar.component.html',
    styleUrls: ['./page-topbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTopbarComponent {}
